import { createMemoryHistory, createRouter as createVueRouter, createWebHistory } from 'vue-router'
import Home from '../pages/Home.vue'
import SettleIn from '../pages/SettleIn.vue'
import About from '../pages/About.vue'

import HomeM from '../pages/mobile/HomeM.vue'
import ProductM from '../pages/mobile/ProductM.vue'
import SelfBuildServicesM from '../pages/mobile/SelfBuildServicesM.vue'
import SettleInM from '../pages/mobile/SettleInM.vue'
import AboutM from '../pages/mobile/AboutM.vue'
import Strategy from '../pages/Strategy.vue'
import StrategyList from '../pages/StrategyList.vue'
import StrategyDetail from '../pages/StrategyDetail.vue'
import Case from '../pages/Case.vue'
import CaseDetail from '../pages/CaseDetail.vue'
import SelfBuildServices from '../pages/SelfBuildServices.vue'
import DecorationServices from '../pages/DecorationServices.vue'

export const routes = [
  { path: '/', name: 'Home', component: Home },
  { path: '/decorationServices', name: 'DecorationServices', component: DecorationServices },
  { path: '/selfBuildServices', name: 'SelfBuild', component: SelfBuildServices },
  { path: '/settlein', name: 'SettleIn', component: SettleIn },
  { path: '/strategy', name: 'Strategy', component: Strategy },
  { path: '/strategy/list/:categoryId', name: 'StrategyListByCategory', component: StrategyList },
  { path: '/strategy/list', name: 'StrategyList', component: StrategyList },
  { path: '/strategy/detail/:id', name: 'StrategyDetailById', component: StrategyDetail },
  { path: '/strategy/detail', name: 'StrategyDetail', component: StrategyDetail },
  { path: '/case', name: 'Case', component: Case },
  { path: '/case/detail/:id', name: 'CaseDetailById', component: CaseDetail },
  { path: '/case/detail', name: 'CaseDetail', component: CaseDetail }, // Added query-style detail route
  { path: '/about', name: 'About', component: About },

  // Mobile routes (prefixed with /m) so existing PC routes remain unchanged
  { path: '/m', name: 'PcHomeM', component: HomeM },
  { path: '/m/product', redirect: '/m/decorationServices' },
  { path: '/m/decorationServices', name: 'PcDecorationServicesM', component: ProductM },
  { path: '/m/selfBuildServices', name: 'PcSelfBuildServicesM', component: SelfBuildServicesM },
  { path: '/m/strategy', redirect: '/m/strategy/list' },
  { path: '/m/strategy/list/:categoryId', name: 'PcStrategyListByCategoryM', component: StrategyList },
  { path: '/m/strategy/list', name: 'PcStrategyListM', component: StrategyList },
  { path: '/m/strategy/detail/:id', name: 'PcStrategyDetailByIdM', component: StrategyDetail },
  { path: '/m/strategy/detail', name: 'PcStrategyDetailM', component: StrategyDetail },
  { path: '/m/case', name: 'PcCaseM', component: Case },
  { path: '/m/case/detail/:id', name: 'PcCaseDetailByIdM', component: CaseDetail },
  { path: '/m/case/detail', name: 'PcCaseDetailM', component: CaseDetail },
  { path: '/m/settlein', name: 'PcSettleInM', component: SettleInM },
  { path: '/m/about', name: 'PcAboutM', component: AboutM },

  // 不存在的路径重定向到首页
  { path: '/:pathMatch(.*)*', name: 'PcNotFound', redirect: '/' }

]

//移动端
function isMobileClient() {
  if (typeof window === 'undefined') return false
  const ua = (navigator && navigator.userAgent) ? navigator.userAgent : ''
  const uaMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua)
  return uaMobile 
}

// PC小尺寸
function isSmallScreen() {
   if (typeof window === 'undefined') return false
   const smallScreen = window.matchMedia ? window.matchMedia('(max-width: 768px)').matches : (window.innerWidth <= 768)
   return smallScreen
}

function toMobilePath(path) {
  if (path === '/') return '/m'
  return `/m${path}`
}

function toPcPath(path) {
  if (path === '/m') return '/'
  if (path === '/m/product') return '/decorationServices'
  if (path.startsWith('/m/')) return path.slice(2)
  return '/'
}

function hasMobileRoute(path) {
  return path === '/'
    || path === '/settlein'
    || path === '/about'
    || path === '/decorationServices'
    || path === '/selfBuildServices'
    || path.startsWith('/strategy')
    || path.startsWith('/case')
}

export function installRouterGuards(router) {
  // Auto-redirect between PC and mobile routes without changing existing logic
  router.beforeEach((to) => {
    if (typeof window === 'undefined') {
      return true
    }
    const queryId = to.query && to.query.id
    if ((to.path === '/case/detail' || to.path === '/m/case/detail' || to.path === '/strategy/detail' || to.path === '/m/strategy/detail') && queryId) {
      const { id, ...query } = to.query
      return { path: `${to.path}/${queryId}`, query, hash: to.hash, replace: true }
    }

    const mobileClient = isMobileClient() || isSmallScreen()
    const isMobileRoute = to.path === '/m' || to.path.startsWith('/m/')

    if (mobileClient && !isMobileRoute && hasMobileRoute(to.path)) {
      return { path: toMobilePath(to.path), query: to.query, hash: to.hash, replace: true }
    }
    if (!mobileClient && isMobileRoute) {
      return { path: toPcPath(to.path), query: to.query, hash: to.hash, replace: true }
    }
    return true
  })
}

export function createRouter() {

  const router = createVueRouter({
    history: typeof window === 'undefined' ? createMemoryHistory() : createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
      if (savedPosition) return savedPosition
      return { left: 0, top: 0 }
    }
  })

  installRouterGuards(router)

  return router
}

// default export for compatibility
export default createRouter
